export default {
    name: 'Tools',
    data() {
        return {
            time: null
        }
    },
    methods: {
        removeFirstDigit(event) {
            let rawPhone = event.clipboardData.getData('text/plain');
            let onlyDigits = rawPhone.replace(/\D/g, '');
            if (onlyDigits[0] === '7' || onlyDigits[0] === '8')
                onlyDigits = onlyDigits.slice(1);
            event.target.value = onlyDigits
        },
        startTimer(timer) {
            setTimeout(() => {
                timer.ms--;
                if (timer.ms > 0)
                    this.startTimer(timer)
            }, 1000);
        },
        debounce(func, timeout, noTimeCheck = false) {
            if(!noTimeCheck)
            {
                if(!this.time)
                {
                    func();
                    this.time = 1;
                    return;
                }
            }
            clearTimeout(this.time);
            this.time = setTimeout(func, timeout ? timeout : 1000);
        },
        valDebounce(func, vals, timeout) {
            if (!this.time) {
                func();
                this.time = 1;
                return;
            }
            clearTimeout(this.time);
            this.time = setTimeout(func(vals), timeout ? timeout : 1000);
        }
    },
}